export default __webpack_public_path__ + "static/media/Icon_Yes.d307db72.svg";